import { SVGIcons } from "@nxplatform/platform-entities/icons";
import { __ } from "@service/api-client/http/helpers/translates";
const analytics = __("Sport_._Group_._analytics");
const boostedOdds = __("Sport_._Group_._Boosted Odds");
const favorites = __("Sport_._Group_._favorites");
const betBuilder = __("Sport_._Group_._Bet builder");
const analyticsMarket = {
  id: analytics,
  name: analytics,
  animated: true,
  icon: SVGIcons.analytics_market_item
};
const favoritesMarket = {
  id: favorites,
  name: favorites,
  animated: false,
  icon: SVGIcons.star
};
const boostedOddsMarket = {
  id: boostedOdds,
  name: boostedOdds,
  animated: false,
  icon: SVGIcons.boostedOdd
};
const betbuilderMarket = {
  id: betBuilder,
  name: betBuilder,
  animated: false,
  icon: SVGIcons.betbuilderMarketItem
};
const analyticsTooltipText = __("Sport_._Tooltip_._Analytics");
export {
  analytics,
  analyticsMarket,
  analyticsTooltipText,
  betBuilder,
  betbuilderMarket,
  boostedOdds,
  boostedOddsMarket,
  favorites,
  favoritesMarket
};
